export default "__VITE_ASSET__BKs5nl8B__"